import { FC } from "react";
import { List } from "@mui/material";
import { useAppDataContext } from "@context/AppContext";
import RemainingRow from "../table/RemainingRow";
import TableRowDivider from "../table/TableRowDivider";

const RefereeTabletRemainingTable: FC = () => {
  const { openSettingsDialog } = useAppDataContext();

  return (
    <List
      sx={{
        display: "grid",
        gridTemplateColumns: "1fr auto 1fr",
        justifyContent: "center",
        alignItems: "center",
      }}
      onClick={openSettingsDialog}
    >
      <TableRowDivider component={"li"} sx={{ gridColumn: "1/4" }} />
      <RemainingRow type={"timeouts"} />
      <TableRowDivider component={"li"} sx={{ gridColumn: "1/4" }} />
      <RemainingRow type={"substitutions"} />
      <TableRowDivider component={"li"} sx={{ gridColumn: "1/4" }} />
      <RemainingRow type={"challenges"} />
      <TableRowDivider component={"li"} sx={{ gridColumn: "1/4" }} />
      <RemainingRow type={"sets"} />
      <TableRowDivider component={"li"} sx={{ gridColumn: "1/4" }} />
    </List>
  );
};

export default RefereeTabletRemainingTable;
